// extracted by mini-css-extract-plugin
var _1 = "StructureItemCourse_iconImage__01c76";
var _2 = "StructureItemCourse_item__bd064";
var _3 = "StructureItemCourse_itemContent__afffd";
var _4 = "StructureItemCourse_itemIcon__9dca2";
export { _1 as "iconImage", _2 as "item", _3 as "itemContent", _4 as "itemIcon" }
